import React from 'react';
import { isEmpty } from 'lodash';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { EditOutlined, CancelOutlined } from '@material-ui/icons';
import List from '@material-ui/core/List';

import ACButton from '../../atoms/ACButton';
import SetItem from './SetItem';
import Item from './Item';
import { getDefaultItem, getItemTypes } from '../../common/items';

import styles from './Items.module.scss';
import { MySwitch } from './ProviderDetails';
import { Checkbox, CircularProgress, FormControlLabel } from '@material-ui/core';
import ACDropDown from 'components/atoms/ACDropDown';
import ACRoundBoxWithDotLayout from 'components/atoms/ACRoundBoxWithDotLayout';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';

export default class Items extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModifyingItem: false,
      enableInactiveArchivedItems: false,
      selectAll: false,
      itemSelect: {},
      itemAction: 'SELECT',
      isItemDeleteModalOpen: false,
      isBulkEditModeOn: false
    };
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onClickItem = this.onClickItem.bind(this);
    this.onAddItem = this.onAddItem.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);
    this.onItemSelect = this.onItemSelect.bind(this);
    this.onItemActionSelect = this.onItemActionSelect.bind(this);
    this.onItemDeleteCancel = this.onItemDeleteCancel.bind(this);
    this.onBulkEditItems = this.onBulkEditItems.bind(this);
    this.onCancelBulkEditItems = this.onCancelBulkEditItems.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    const initialSelect = this.props.items
      .filter(item => item.status === 'active')
      .reduce((acc, item) => {
        acc[item.id] = false;
        return acc;
      }, {});
    this.setState({
      itemSelect: initialSelect
    })
  }

  componentDidUpdate(prevProps) {
    const { bulkDeleteInProgress } = this.props;
    const eachItemSelectedForDeletion = Object.values(this.state.itemSelect).every(val => val === true);
    const activeItems = this.props.items
        .filter(item => item.status === 'active');

    if( prevProps.bulkDeleteInProgress !== bulkDeleteInProgress && bulkDeleteInProgress === false) {
      this.onItemDeleteCancel();
    }

    if(!this.state.selectAll && eachItemSelectedForDeletion) {
      this.setState({
        selectAll: true
      })
    }
    if((this.state.selectAll && !eachItemSelectedForDeletion) || (prevProps.items !== this.props.items)) {
      this.setState({
        selectAll: false
      })
      if((prevProps.items !== this.props.items)) {
        this.onCancelBulkEditItems();
      }
    }



    if(activeItems.length > 0 && Object.keys(this.state.itemSelect).length === 0) {
        const initialSelect = activeItems
        .reduce((acc, item) => {
          acc[item.id] = false;
          return acc;
        }, {});
      this.setState({
        itemSelect: initialSelect
      })
    }
  }


  onOpenModal() {
    this.setState({ isModifyingItem: true });
  }

  onCloseModal = () => {
    this.setState({ isModifyingItem: false });
  };

  onClickItem(item) {
    this.props.onSelectItemFunc(item);
    this.onOpenModal();
  }

  onAddItem() {
    this.props.onSelectItemFunc(getDefaultItem());
    this.onOpenModal();
  }

  onBulkEditItems() {
    this.setState({
      isBulkEditModeOn: true
    })
  }

  onCancelBulkEditItems() {
      this.setState(prevState => {
        const updatedItemSelect = {};

        Object.keys(prevState.itemSelect).forEach(id => {
            updatedItemSelect[id] = false;
        });

        return {
          isBulkEditModeOn: false,
          itemSelect: updatedItemSelect
        }
      }
    )
  }

  onSelectAll = () => {
    this.setState(prevState => {
      const updatedItemSelect = {};

      Object.keys(prevState.itemSelect).forEach(id => {
          updatedItemSelect[id] = !prevState.selectAll;
      });

      return {
        selectAll: !prevState.selectAll,
        itemSelect: updatedItemSelect
      }
    }
  )
  }

  onItemDeleteCancel = () => {
      this.setState({
        isItemDeleteModalOpen: false,
        itemAction: 'SELECT'
      })
  }

  onItemActionSelect = (e) => {
    this.setState({
      itemAction: e.target.value
    })
    if(e.target.value === 'ARCHIVE') {
      this.setState({
        isItemDeleteModalOpen: true
      })
    }
  }

  onItemSelect = (id) => {
    this.setState(prevState => {

      return {
        itemSelect: {
          ...prevState.itemSelect,
          [id]: !prevState.itemSelect[id]
        }
      };
    });
  };

  renderItems(items) {
    if (isEmpty(items)) return;

    let itemsComponents = [];

    if (items) {
      items.forEach((item) => {
        itemsComponents.push(
          <>
            <Item
              key={item.id}
              item={item}
              currencySymbol={this.props.currencySymbol}
              onClickItemFunc={this.onClickItem}
              onCloneItemFunc={this.props.onCloneItemFunc}
              onItemSelectFunc={this.onItemSelect}
              selected={this.state.itemSelect[item.id]}
              isBulkEditModeOn={this.state.isBulkEditModeOn}
            />
          </>
        );
      });
    }

    return itemsComponents;
  }

  async onChangeInactiveArchivedToggle(event) {
    this.setState(prevState => {
      const updated = {};
      for (let key in prevState.itemSelect) {
        if (prevState.itemSelect.hasOwnProperty(key)) {
          updated[key] = false;
        }
      }
      return { itemSelect: updated, enableInactiveArchivedItems: !this.state.enableInactiveArchivedItems, isBulkEditModeOn: false};
    });
  }

  render() {
    let { items, item, media, uploadMediaFunc} = this.props;
    const selectedItemsForDeletion = Object.keys(this.state.itemSelect).filter(key => this.state.itemSelect[key] === true);
    const itemSelectedForDeletion = selectedItemsForDeletion.length > 0;
    let subItems = [];
    if (!isEmpty(items)) {
      subItems = items.filter((i) => {
        return i.id !== item.id;
      });
    }

    return (
      <div className={styles.root}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
        <MySwitch
            checked={this.state.enableInactiveArchivedItems}
            onChange={(event)=>{
              this.onChangeInactiveArchivedToggle(event)
            }}
            color="primary"
            name="checkedB"
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
          Show inactive/archived
        </div>

        {
          this.state.enableInactiveArchivedItems ? (
            <>
              <div className={styles.title}>
                {
                  items.filter((i) => i.status === 'inactive').length > 0 && (
                    <div style={{width: '100%'}}>
                      <div style={{padding: '0 0 12px 0'}}>
                      Inactive Items
                      </div>
                      <div>
                        <List className={styles.itemList}>{this.renderItems(items.filter((i) => i.status === 'inactive'))}</List>
                      </div>
                    </div>
                  )
                }
              </div>
              <div className={styles.title}>
                {
                  items.filter((i) => i.status === 'archived').length > 0 && (
                    <div style={{width: '100%'}}>
                      <div style={{padding: '0 0 12px 0'}}>
                      Archived Items
                      </div>
                      <div>
                        <List className={styles.itemList}>{this.renderItems(items.filter((i) => i.status === 'archived'))}</List>
                      </div>
                    </div>
                  )
                }
              </div>
            </>
          ):
          (
            <>
              <div className={styles.title}>
                Available Items

                <div className={styles.availableItemsAction}>
                    {
                      this.state.isBulkEditModeOn ? (
                        <div className={styles.bulkItemsActionWrapper}>
                          <ACRoundBoxWithDotLayout layoutStyle={{
                            backgroundColor: '#52A8EF',
                            color: 'white',
                            borderColor: '#616161',
                            borderWidth: '1px',
                            borderStyle: 'none',
                            dotColor: '',
                            borderRadius: '16px'
                            }
                              }>
                            <div className={styles.itemActionSelect}>
                              <ACDropDown
                                  text={'Select'}
                                  isEditable={true}
                                  options={['SELECT','ARCHIVE']}
                                  selected={ this.state.itemAction || 'SELECT'}
                                  onChangeFunc={(e) => this.onItemActionSelect(e)}
                                  backgroundColor="transparent"
                                  isMultiple={false}
                                  // color={currencyStyle.color}
                                />
                            </div>
                          </ACRoundBoxWithDotLayout>
                          <CancelOutlined 
                          onClick={this.onCancelBulkEditItems}
                          style={{
                            cursor: 'pointer',
                            width: 18,
                            height: 18
                          }} />
                        </div>
                      ) :
                      (
                        <ACButton
                          text={'Edit'}
                          onClick={() => {
                            console.log('onClickEdit')
                          }}
                          icon={<EditOutlined style={{
                            width: 20,
                            height: 20
                          }}/>}
                          iconLast={true}
                          onClickFunc={this.onBulkEditItems}
                        />
                      )
                    }
                  <ACButton
                    text={'Add'}
                    icon={<AddCircleOutlineIcon />}
                    iconLast={true}
                    onClickFunc={this.onAddItem}
                  />
                </div>
                
              </div>
              {
                <div>
                {
                  this.state.isBulkEditModeOn &&
                  items.filter((i) => i.status === 'active').length > 0 && (
                    <FormControlLabel
                      className={styles.itemSelectAll}
                      control={<Checkbox color="primary" checked={this.state.selectAll} onChange={this.onSelectAll} />}
                      label={'Select All'}
                      key={'selectAllItems'}
                    />
                  )
                }
                  <List className={styles.itemList}>{this.renderItems(items.filter((i) => i.status === 'active'))}</List>
                </div>
              }
            </>
          )
        }

        <SetItem
          item={item}
          subItems={subItems}
          itemTypes={getItemTypes()}
          isModifying={this.state.isModifyingItem}
          media={media}
          onCloseFunc={this.onCloseModal}
          onSaveItemFunc={this.props.onSaveItemFunc}
          uploadMediaFunc={uploadMediaFunc}
        />
        <Dialog open={this.state.isItemDeleteModalOpen} onClose={this.onItemDeleteCancel}>
          {
            this.props.bulkDeleteInProgress ? 
            <DialogContent>
              <CircularProgress /> 
            </DialogContent>
            :
            <>
              <DialogTitle>Move to Archive?</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {itemSelectedForDeletion
                    ? (
                      <p>
                        Are you sure you want to archive selected items?
                      </p>
                    )
                    :
                    (
                      <p>
                        No item selected to archive. Please select an item to continue?
                      </p>
                  ) }
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.onItemDeleteCancel} color="primary">
                  Cancel
                </Button>
                <Button disabled={itemSelectedForDeletion ? false : true} onClick={() => this.props.onBulkDeleteItemsFunc(selectedItemsForDeletion)} color="error" variant="contained">
                  Archive
                </Button>
              </DialogActions>
            </>
          }
        </Dialog>
      </div>
    );
  }
}
